import React, { useState, Suspense, lazy } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Layout from './components/Shared/Layout';

const Dashboard  = lazy(() => import('./components/Dashboard/Dashboard'));
const Saisie     = lazy(() => import('./components/Shared/Saisie'));
const Problemes  = lazy(() => import('./components/Problemes/Problemes'));
const AvanTable  = lazy(() => import('./components/Shared/AvanTable'));
const Users      = lazy(() => import('./components/Shared/Users'));
const Planning   = lazy(() => import('./components/Planning/Planning'));

function AppInner() {
  const { user, loading } = useAuth();
  const [page, setPage] = useState('dashboard');

  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f4f3ee' }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ fontSize:40, marginBottom:12 }}>🏗️</div>
        <div style={{ color:'#6b6b67' }}>Chargement…</div>
      </div>
    </div>
  );

  if (!user) return <Login />;

  const renderPage = () => {
    switch (page) {
      case 'dashboard': return <Dashboard />;
      case 'saisie':    return <Saisie />;
      case 'go':        return <AvanTable corps="go" titre="Gros œuvre + Étanchéité" />;
      case 'fluides':   return <AvanTable corps="fluides" titre="Fluides" />;
      case 'elec':      return <AvanTable corps="elec" titre="Électricité" />;
      case 'secondaire':return <AvanTable corps="secondaire" titre="Lot Secondaire" />;
      case 'exterieurs':return <AvanTable corps="exterieurs" titre="Extérieurs" />;
      case 'problemes': return <Problemes />;
      case 'planning':  return <Planning />;
      case 'users':     return <Users />;
      default:          return <Dashboard />;
    }
  };

  return (
    <Layout page={page} setPage={setPage}>
      <Suspense fallback={<div style={{ padding:'2rem', color:'#6b6b67', textAlign:'center' }}>Chargement…</div>}>
        {renderPage()}
      </Suspense>
    </Layout>
  );
}

export default function App() {
  return <AuthProvider><AppInner /></AuthProvider>;
}
